import React from "react";
import { Row, Col } from "react-bootstrap";

import { SectionTitle } from "../components/SectionTitle";
import { FaCogs, FaMicrochip, FaSatelliteDish, FaCube } from "react-icons/fa";
import { FeatureItem } from "../components/FeatureItem";

export class Sectors extends React.Component {
    render() {
        return (
            <section id="sectors">
                <div>
                    <Row>
                        <SectionTitle title="Sectors" />
                    </Row>
                    <Row>
                        <Col xs={6} xl={3}>
                            <FeatureItem title="Digital & FPGA Design" icon={FaMicrochip} />
                        </Col>

                        <Col xs={6} xl={3}>
                            <FeatureItem title="Hardware Design" icon={FaCogs} />
                        </Col>

                        <Col xs={6} xl={3}>
                            <FeatureItem title="Communication Systems" icon={FaSatelliteDish} />
                        </Col>
                        <Col xs={6} xl={3}>
                            <FeatureItem title="Electronic Warfare" icon={FaCube} />
                        </Col>

                    </Row>
                </div>
            </section>
        );
    }
}
